import { App as AntdApp, ConfigProvider } from 'antd';
import { Provider } from 'jotai';
import { RouterProvider } from 'react-router-dom';
import router from './router';
import { store } from './store';
import AuthProvider from './features/auth/providers/AuthProvider';

function App() {
  return (
    <Provider store={store}>
      <ConfigProvider>
        <AntdApp>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </AntdApp>
      </ConfigProvider>
    </Provider>
  );
}

export default App;
